// extracted by mini-css-extract-plugin
export default {"default":"VerticalSpacer_default__uf6Kl","topOnly":"VerticalSpacer_topOnly__WTNN0","bottomOnly":"VerticalSpacer_bottomOnly__rW9HJ","none":"VerticalSpacer_none__HzKxP"};